// extracted by mini-css-extract-plugin
export default {"form__group":"customInput_form__group__oAr-K","form__field":"customInput_form__field__oLS5g","form__label":"customInput_form__label__Hjdrf"};